import Darkener from './Darkener';
import { DarkenerComponent } from './models/DarkenerComponent';
import spinner from './images/spinner.svg';
import style from './styles/App.module.scss';
import { useEffect, useRef } from 'react';

// TODO: Loading alt intl

export default function LoadingState({ show }) {
    const drk = useRef<DarkenerComponent>(null);

    useEffect(() => {
        if (show && drk.current) drk.current.enable();
        else if (drk.current) drk.current.disable();
    }, [show, drk.current]);

    if (show) {
        return <div className={`${ style.loadingWrapper } ${ style.loadingState }`}>
            <Darkener ref={drk} switchOff={(e) => {}} />
            <img src={spinner} alt={'Loading'} />
        </div>;
    }
    return <div className={style.loadingWrapper} />;
}